const scrollMainContentToTop = () => {
  document.getElementById('main-content')?.scroll({ behavior: 'smooth', top: 0, left: 0 });
};

export const domHelpers = {
  scrollMainContentToTop
};
